module.exports = __webpack_public_path__ + "83b9b34db2f6b8b561dc6ed69a15b5d9.pdf";